var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MyJobsTray',{attrs:{"status":_vm.status},on:{"MyJobTrayLabStatus5WantToSwapTabToView":_vm.MyJobTrayLabStatus5WantToSwapTabToView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }